// Método genérico para devolver el id para el trackBy del ngFor
export const trackBy = <T extends { id: string }>(index: number, item: T): T | string | number => item?.id || item || index;
